module.exports = __webpack_public_path__ + "img/proctor-require-3.2b56f5a9.png";